import { Directive, Renderer2, forwardRef, ElementRef, HostListener  } from '@angular/core';
import { NG_VALUE_ACCESSOR, DefaultValueAccessor } from '@angular/forms';

const TITLECASE_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TitleCaseDirective),
  multi: true,
};

@Directive({
  selector: '[appTitleCase]',
  host: {
    // When the user updates the input
    '(input)': 'onInput($event.target.value)',
    '(blur)': 'onTouched()',
  },
  providers: [
    TITLECASE_INPUT_CONTROL_VALUE_ACCESSOR,
  ],
})
export class TitleCaseDirective extends DefaultValueAccessor {

  constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef, false);
  }

  writeValue(value: any): void {
    const transformed = this.transformValue(value);

    super.writeValue(transformed);
  }

  onInput(value: any): void {
    const transformed = this.transformValue(value);

    super.writeValue(transformed);
    this.onChange(transformed);
  }

  private transformValue(value: any): any {
    let result = value;
    if ( result == value && typeof value === 'string' ) {
      if ( value.length >= 1 ) {
        const arr: string[] = value.split('');
        arr[0] = arr[0].toUpperCase();
        result = arr.join('');
      }

      result = result.replace(/ß/g, 'ss');
      result = result.replace(/ẞ/g, 'SS');
      result = result.replace(/ä/g, 'ae');
      result = result.replace(/ö/g, 'oe');
      result = result.replace(/ü/g, 'ue');
      result = result.replace(/Ä/g, 'Ae');
      result = result.replace(/Ö/g, 'Oe');
      result = result.replace(/Ü/g, 'Ue');

      result = result.replace(/æ/g, 'ae');
      result = result.replace(/ø/g, 'oe');
      result = result.replace(/å/g, 'aa');
      result = result.replace(/Æ/g, 'Oe');
      result = result.replace(/Ø/g, 'Oe');
      result = result.replace(/Å/g, 'AA');

      result = result.replace(/á/g, 'a');
      result = result.replace(/à/g, 'a');
      result = result.replace(/À/g, 'A');
      result = result.replace(/Á/g, 'A');

      result = result.replace(/ë/g, 'e');
      result = result.replace(/è/g, 'e');
      result = result.replace(/é/g, 'e');
      result = result.replace(/ê/g, 'e');

      result = result.replace(/È/g, 'E');
      result = result.replace(/É/g, 'E');
      result = result.replace(/Ë/g, 'E');
      result = result.replace(/Ê/g, 'E');

      result = result.replace(/Ê/g, 'E');
      result = result.replace(/ç/g, 'c');

      result = result.replace(/ú/g, 'u');

    }

    return result;
  }

}
